import Storage from "./storage";

export default [Storage];
